import api from './api';

interface ArticuloXListaPrecio {
    codigoLista: string;
    codigoArticulo: string;
    descripcion: string;
    codigoMoneda?: string;
    precioVta?: number;
    precioCosto?: number;
    propio: string;
    iva: string;
    descuento?: string;
    flete?: number;
    fleteFp: string;
    porcentaje?: number;
    codigoRamo: string;
    nombreRamo: string;
    codigoLinea: string;
    nombreLinea: string;
    codigoClase: string;
    nombreClase?: string;
    variacion?: number;
    variacionFp?: string;
    variacionBasadaEn?: string;
    variacionSigno?: string;
    usuario?: string;
    fechaActualizacion?: Date;
    horaActualizacion?: Date;
    minMarkUp?: number;
}

interface ArticuloXListaPrecioSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    codigoLista?: string;
    codigoRamo?: string;
    codigoLinea?: string;
    codigoClase?: string;
}

interface ArticuloXListaPrecioPagedResult {
    items: ArticuloXListaPrecio[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const articuloXListaPrecioService = {
    getArticuloXListaPrecios: async (params: ArticuloXListaPrecioSearchParams): Promise<ArticuloXListaPrecioPagedResult> => {
        const response = await api.get<ArticuloXListaPrecioPagedResult>('/api/articuloxlistaprecios', { params });
        return response.data;
    },

    getArticuloXListaPrecio: async (codigoLista: string, codigoArticulo: string): Promise<ArticuloXListaPrecio> => {
        const response = await api.get<ArticuloXListaPrecio>(`/api/articuloxlistaprecios/${codigoLista}/${codigoArticulo}`);
        return response.data;
    },

    createArticuloXListaPrecio: async (articuloXListaPrecio: ArticuloXListaPrecio): Promise<ArticuloXListaPrecio> => {
        const response = await api.post<ArticuloXListaPrecio>('/api/articuloxlistaprecios', articuloXListaPrecio);
        return response.data;
    },

    updateArticuloXListaPrecio: async (codigoLista: string, codigoArticulo: string, articuloXListaPrecio: ArticuloXListaPrecio): Promise<void> => {
        await api.put(`/api/articuloxlistaprecios/${codigoLista}/${codigoArticulo}`, articuloXListaPrecio);
    },

    deleteArticuloXListaPrecio: async (codigoLista: string, codigoArticulo: string): Promise<void> => {
        await api.delete(`/api/articuloxlistaprecios/${codigoLista}/${codigoArticulo}`);
    }
};

export default articuloXListaPrecioService; 